import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const cartPricesAreHiddenSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('hideCartPrices'),
)

export default cartPricesAreHiddenSelector
